const overwrite = palette => ({
  MuiButton: {
    styleOverrides: {
      root: {
        outline: 'none !important',
        boxShadow: 'none',
        textTransform: 'none',
      },
    },
  },
  MuiButtonBase: {
    styleOverrides: {
      root: {
        outline: 'none !important',
        
        '&:focus' : {
          outline: 'none !important',
        },
      },
    },
  },
  MuiFormControlLabel: {
    styleOverrides: {
      label:{
        fontSize: '0.8rem !important',
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        boxShadow: 'none',
        backgroundColor: palette.background.primary,
        color: 'text.primary',
        padding: '0 14px',
        borderBottom: `1px solid ${palette.gray.G20}`,
      },
    },
  },
  MuiToolbar: {
    styleOverrides: {
      root: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: '10px',
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        backgroundColor: palette.background.primary,
      },
    },
  },
  MuiBackdrop: {
    styleOverrides: {
      invisible: {
        visibility: 'hidden', // TO fix the overlay problem when user change the route by clicking the menu items
      },
    },
  },
})

export default overwrite;